import styles from './ConsultingDetail.module.css';
import SubPageTop from '../../components/SubPageTop';
import ScrollReveal from '../../components/Ui/ScrollReveal';
import { FiSearch, FiMap, FiPenTool, FiFileText, FiMonitor } from 'react-icons/fi';

const processData = [
    {
        id: 1,
        icon: FiSearch,
        title: '제품분석',
        items: ['라이프 스타일 분석', '내/외면 감성적 분석']
    },
    {
        id: 2,
        icon: FiMap,
        title: '현장 조사',
        items: ['현장, 주변환경 분석', '고객 의견 리서치']
    },
    {
        id: 3,
        icon: FiPenTool,
        title: '색채 계획 수립',
        items: ['색채디자인 컨셉 수립', '메인컬러, 배색 설계']
    },
    {
        id: 4,
        icon: FiFileText,
        title: '색채 디자인 제안',
        items: ['제안서 제작 및 제출', '디자인 최종 선정']
    },
    {
        id: 5,
        icon: FiMonitor,
        title: '시뮬레이션 검토',
        items: ['시뮬레이션', '색채 브랜딩 통보']
    }
];

function EnterpriseEnvironment() {
    return (
        <div className={styles.consultingDetail}>
            <SubPageTop title="Consulting" />
            <div className={styles.consultingDetailContent}>
                <ScrollReveal>
                    <section className={styles.section01}>
                    <div className={styles.imgbox}>
                        <img
                            src="/image/consulting-detail-section01-01.png"
                            alt="컬러 이미지"
                        />
                    </div>
                    <div className={styles.infoBox}>
                        <div className={styles.infoHeader}>
                            <p className={styles.subtitle}>
                                Color Consulting
                            </p>
                            <p className={styles.koTitle}>
                                환경 컬러 컨설팅
                            </p>
                        </div>
                        <div className={styles.infoDetail}>
                            <div className={styles.infoDesc}>
                                환경 색채디자인은,
                                <br />
                                브랜드의 아이덴티티 수립 및 심미적 도시경관의 조화로운 연출을 위한 시각적 편안함을 제공합니다.
                            </div>
                            <ul className={styles.infoList}>
                                <li>
                                    <span className={styles.pointcolor}>·</span>
                                    <span>브랜드 및 기관의 정체성과 이미지 확립에 바람직한 도움이 되고자 건축물 및 조경환경을 대상으로 하는 색채 사용 기준 제시</span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>·</span>
                                    <span>
                                        색채의 활용으로 차별화 된 환경 디자인의 기준을 마련하며, 지향 이미지를 바탕으로 향후 계획에 필요한 색채 팔레트 메뉴얼 제안
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.pointcolor}>·</span>
                                    <span>심미성, 편리성, 생활을 고려한 환경 색채디자인으로 건물, 공간 및 브랜드에 대한 긍정적 이미지 부여 및 쾌적성, 편리성, 안정성을 도모하여 심리적 편안함 제공</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
                </ScrollReveal>
                <ScrollReveal>
                    <section className={styles.section02}>
                    <div className={styles.titleWrap}>
                        <p className={styles.programSubtitle}>
                            process
                        </p>
                        <h2 className={styles.title}>
                            컨설팅 프로세스
                        </h2>
                    </div>
                    <div className={styles.line}></div>
                    <div className={styles.processLineWrapper}>
                        {processData.map((step, index) => {
                            const Icon = step.icon;
                            return (
                                <>
                                    <div key={step.id} className={styles.processLineStep}>
                                        <div className={styles.processLineIconCircle}>
                                            <Icon className={styles.processLineIcon} />
                                        </div>
                                        <h3 className={styles.processLineStepTitle}>{step.title}</h3>
                                        <ul className={styles.processLineStepList}>
                                            {step.items.map((item, idx) => (
                                                <li key={idx}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    {index < processData.length - 1 && (
                                        <div className={styles.processLineConnector}></div>
                                    )}
                                </>
                            );
                        })}
                    </div>
                </section>
                </ScrollReveal>
            </div>
        </div>
    );
}

export default EnterpriseEnvironment;

